An array of sources from which the candidate was obtained from.
